<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Histórico - Actualizaciones PQ</strong>
                    </div>
                    <b-row>
                        <b-col sm="4">
                            <b-form-group class="d-flex flex-column">
                                <label style="margin-bottom: 5px;">Empresa <span class="text-danger"
                                        v-text="'(*)'" /></label>
                                <el-select class="mb-1" placeholder="Buscar empresa" v-model="filterBenefits.company_id"
                                    filterable clearable remote no-data-text="No hay datos que coincidan"
                                    no-match-text="No hay datos que coincidan" :remote-method="getCompany"
                                    @change="changeCompany">
                                    <el-option v-for="company in companies" :key="company.id" :label="company.nombre"
                                        :value="company.id">
                                    </el-option>
                                </el-select>
                            </b-form-group>
                        </b-col>
                        <template v-if="filterBenefits.company_id">
                            <b-col sm="4">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Nombre de Producto</label>
                                    <b-form-input style="height: 40px;" placeholder="Buscar producto" type="text"
                                        v-model="filterBenefits.search" />
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Fabricante</label>
                                    <el-select class="mb-1" style="height: 40px;" placeholder="Buscar fabricante" filterable
                                        clearable remote v-model="filterBenefits.manufacturer_id"
                                        no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                                        :remote-method="getProducerByName">
                                        <el-option v-for="item in producers" :key="item.id" :label="item.nombre"
                                            :value="item.id" />
                                    </el-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Pagos</label>
                                    <el-select v-model="filterBenefits.payment" size="sm" class="form-contol" clearable>
                                        <el-option v-for="(is_payment, index) in isPayment" :value="is_payment.value"
                                            :label="is_payment.label" :key="index" />
                                    </el-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">En Uso</label>
                                    <el-select v-model="filterBenefits.in_use" size="sm" class="form-contol" clearable>
                                        <el-option v-for="(in_use, index) in inUse" :value="in_use.value"
                                            :label="in_use.label" :key="index" />
                                    </el-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Beneficio</label>
                                    <el-select v-model="filterBenefits.benefit" size="sm" class="form-contol" clearable>
                                        <el-option v-for="(is_benefit, index) in inUse" :value="is_benefit.value"
                                            :label="is_benefit.label" :key="index" />
                                    </el-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Fecha de Actualización</label>
                                    <el-date-picker v-model="filterBenefits.date_updated" type="daterange"
                                        range-separator="a" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                        start-placeholder="Fecha inicio" end-placeholder="Fecha fin" class="w-100">
                                    </el-date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Fecha de Documento</label>
                                    <el-date-picker v-model="filterBenefits.date_document" type="daterange"
                                        range-separator="a" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                        start-placeholder="Fecha inicio" end-placeholder="Fecha fin" class="w-100">
                                    </el-date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group class="d-flex flex-column">
                                    <label style="margin-bottom: 5px;">Ubicación</label>
                                    <tree-select v-model="filterBenefits.location_id" :searchable="true" :show-count="true"
                                        :multiple="true" :defaultExpandLevel="Infinity" :options="ubicaciones_filtro"
                                        value-consists-of="ALL_WITH_INDETERMINATE" :normalizer="normalizer" />
                                </b-form-group>
                            </b-col>
                        </template>
                    </b-row>
                    <b-row v-if="filterBenefits.company_id" class="mt-2">
                        <b-col lg="3">
                            <b-button-group size="md">
                                <b-button @click="getProductBenefits" variant="primary">
                                    <i class="fa fa-search fa-lg"></i>
                                    <span>Buscar</span>
                                </b-button>
                                <b-button @click="resetFilterBenefits" class="mx-2">
                                    <i class="fa fa-eraser fa-lg"></i>
                                    <span> Limpiar</span>
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4" v-if="filterBenefits.company_id">
                        <b-col sm="2" v-if="accompanied.total_products >= 0">
                            <b-button block v-b-toggle.accordion-8 variant="primary">
                                Ver Acumulado
                            </b-button>
                        </b-col>
                        <b-col sm="7">
                            <b-collapse id="accordion-8" :visible="false" accordion="my-accordion" role="tabpanel">
                                <b-card>
                                    <bar-chart :data="chartsData" :download="false"
                                        :colors="[['#01579B', '#0091EA', '#B3E5FC']]">
                                    </bar-chart>
                                </b-card>
                            </b-collapse>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3" v-if="filterBenefits.company_id">
                        <b-col sm="12">
                            <b-table responsive hover striped thead-class="table-active" show-empty
                                empty-text="No hay productos para mostrar" :fields="colums" :items="productBenefits.data">
                                <template v-slot:cell(userUpdate)="data">
                                    <span v-if="data.item.product && data.item.product.history_benefits">
                                        <span v-if="data.item.product.history_benefits.user_created">
                                            {{ data.item.product.history_benefits.user_created.name.toUpperCase() }}
                                        </span>
                                        <span v-else>NO REGISTRA</span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(dateUpdate)="data">
                                    <span v-if="data.item.product.history_benefits">
                                        <span>
                                            {{ data.item.product.history_benefits.created_at }}
                                        </span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(productName)="data">
                                    <span
                                        v-if="data.item.product.history_change && data.item.product.history_change.length > 0">
                                        <div v-for="(change, index) in data.item.product.history_change" :key="change.id">
                                            <span v-if="change.field_name === 'nombre'">
                                                {{ change.current_value }}
                                            </span>
                                            <span v-else-if="index === 0">{{ data.item.product.nombre }}</span>
                                        </div>
                                    </span>
                                    <span v-else>{{ data.item.product.nombre }}</span>
                                </template>
                                <template v-slot:cell(newProductName)="data">
                                    <span
                                        v-if="data.item.product.history_change && data.item.product.history_change.length > 0">
                                        <div v-for="(change, index) in data.item.product.history_change" :key="change.id">
                                            <span v-if="change.field_name === 'nombre'">
                                                {{ change.last_value }}
                                            </span>
                                            <span v-else-if="index === 0">NO REGISTRA</span>
                                        </div>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(datefds)="data">
                                    <span v-if="data.item.product.history_benefits">
                                        <span v-if="data.item.product.history_benefits.document_type == 'FDS'">
                                            {{ data.item.product.history_benefits.current_date_document }}
                                        </span>
                                        <span v-else>NO REGISTRA</span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(newDatefds)="data">
                                    <span v-if="data.item.product.history_benefits">
                                        <span v-if="data.item.product.history_benefits.document_type == 'FDS'">
                                            {{ data.item.product.history_benefits.last_date_document }}
                                        </span>
                                        <span v-else>NO REGISTRA</span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(datemsds)="data">
                                    <span v-if="data.item.product.history_benefits">
                                        <span v-if="data.item.product.history_benefits.document_type == 'MSDS'">
                                            {{ data.item.product.history_benefits.last_date_document }}
                                        </span>
                                        <span v-else>NO REGISTRA</span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(newDatemsds)="data">
                                    <span v-if="data.item.product.history_benefits">
                                        <span v-if="data.item.product.history_benefits.document_type == 'MSDS'">
                                            {{ data.item.product.history_benefits.last_date_document }}
                                        </span>
                                        <span v-else>NO REGISTRA</span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(use)="data">
                                    <span v-if="data.item.in_use !== undefined && data.item.in_use !== null">
                                        <span>
                                            {{ data.item.in_use ? 'SI' : 'NO' }}
                                        </span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(payment)="data">
                                    <span v-if="data.item.product_rpq">
                                        <span>
                                            {{ data.item.product_rpq.pago ? 'SI' : 'NO' }}
                                        </span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(companyUpdate)="data">
                                    <span v-if="data.item.product && data.item.product.history_benefits">
                                        <span v-if="data.item.product.history_benefits.company_updated">
                                            {{ data.item.product.history_benefits.company_updated.nombre.toUpperCase() }}
                                        </span>
                                        <span v-else>NO REGISTRA</span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(benefit)="data">
                                    <span
                                        v-if="data.item.product.history_benefits && data.item.product.history_benefits.is_benefit !== 2">
                                        <span>
                                            {{ data.item.product.history_benefits.is_benefit ? 'SI' : 'NO' }}
                                        </span>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                                <template v-slot:cell(locations)="data">
                                    <span v-if="data.item.ubicaciones && data.item.ubicaciones.length > 0">
                                        <div>
                                            <span v-for="(ubicacion, index) in data.item.ubicaciones" :key="ubicacion.id">
                                                <b-badge variant="warning"
                                                    v-if="ubicacion.location && ubicacion.location.description">{{
                                                        ubicacion.location.description }}</b-badge>
                                                <span v-if="index < data.item.ubicaciones.length - 1">&nbsp;</span>
                                            </span>
                                        </div>
                                    </span>
                                    <span v-else>NO REGISTRA</span>
                                </template>
                            </b-table>
                        </b-col>
                        <b-col sm="12">
                            <el-pagination small class="float-right" :page-sizes="[5, 30, 50, 100]"
                                layout="total, sizes, prev, pager, next" :page-size="filterBenefits.limit"
                                v-model="filterBenefits.page" @size-change="setPerPageBenefits"
                                @current-change="setPageBenefits" :current-page.sync="filterBenefits.page"
                                :total="productBenefits.total" :pager-count="5" />
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TreeSelect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
    name: 'updatePQ-index',
    components: {
        TreeSelect,
    },
    data() {
        return {
            colums: [
                {
                    key: "userUpdate",
                    label: "Usuario Actualizador",
                    sortable: false,
                },
                {
                    key: "dateUpdate",
                    label: "Fecha Actualización",
                    sortable: false,
                },
                {
                    key: "productName",
                    label: "Nombre de Producto",
                    sortable: false,
                },
                {
                    key: "newProductName",
                    label: "Nuevo Nombre de Producto",
                    sortable: false,
                },
                {
                    key: "product.manufacturer.nombre",
                    label: "Fabricante",
                    sortable: false,
                },
                {
                    key: "datefds",
                    label: "Fecha Anterior FDS",
                    sortable: false,
                    thStyle: "min-width: 130px",
                },
                {
                    key: "newDatefds",
                    label: "Fecha Nueva FDS",
                    sortable: false,
                    thStyle: "min-width: 130px",
                },
                {
                    key: "datemsds",
                    label: "Fecha Anterior MSDS",
                    sortable: false,
                    thStyle: "min-width: 130px",
                },
                {
                    key: "newDatemsds",
                    label: "Fecha Nueva MSDS",
                    sortable: false,
                    thStyle: "min-width: 130px",
                },
                {
                    key: "use",
                    label: "Uso",
                    sortable: false,
                },
                {
                    key: "payment",
                    label: "Pago",
                    sortable: false,
                },
                {
                    key: "benefit",
                    label: "Beneficio",
                    sortable: false,
                },
                {
                    key: "companyUpdate",
                    label: "Empresa Actualizadora",
                    sortable: false,
                },
                {
                    key: "locations",
                    label: "Ubicaciones",
                    sortable: false,
                },
            ],
            inUse: [
                {
                    value: 1,
                    label: 'SI'
                },
                {
                    value: 0,
                    label: 'NO'
                }
            ],
            isPayment: [
                {
                    value: 1,
                    label: 'SI'
                },
                {
                    value: 0,
                    label: 'NO'
                }
            ],
            isBenefit: [
                {
                    value: 1,
                    label: 'SI'
                },
                {
                    value: 0,
                    label: 'NO'
                }
            ],
        }
    },
    computed: {
        chartsData() {
            return {
                ['(' + this.accompanied.is_benefit + ') Beneficio']: this.accompanied.is_benefit,
                ['(' + this.accompanied.not_benefit + ') No Beneficio']: this.accompanied.not_benefit,
                ['(' + this.accompanied.total_products + ') Total']: this.accompanied.total_products,
            }
        },
        ...mapState('updatePQ', ['productBenefits', 'accompanied', 'filterBenefits']),
        ...mapState("accidents_high", ['companies', 'producers']),
        ...mapState('tareas', ['ubicaciones_filtro']),
    },
    async mounted() {
        await this.existCompany();
    },
    methods: {
        ...mapMutations('updatePQ', ['resetFilterBenefits', 'resetFilterCompany']),
        ...mapActions('updatePQ', ['getProductBenefits', 'setPerPageBenefits', 'setPageBenefits']),
        ...mapActions("accidents_high", ['getCompany', 'getProducerByName']),
        ...mapActions('analysis', ['obtenerUbicacionesFiltro']),

        async changeCompany() {
            this.resetFilterCompany();
            await this.existCompany();
        },

        async existCompany() {
            if (this.filterBenefits.company_id) {
                await this.getProductBenefits();
                await this.obtenerUbicacionesFiltro(this.filterBenefits.company_id);
            }
        },

        normalizer(node) {
            return {
                children: node.children && node.children.length ? node.children : 0,
            };
        },
    },
}
</script>
